import React from 'react';
import { DateInput } from 'react-admin';


const SgxDateInput = ({ source, ...props})  => {
    return <DateInput {...props} source={source} />
}

export default SgxDateInput;
